import React, { useRef, useEffect } from "react";
import { OfferInfoContainer, Input2 } from "components";
import { useMainContext } from "contexts";

export const InfoInput = ({
  label,
  inputId,
  shouldMoveNextOnEnter = true,
  className,
  type,
  disabled = false
}) => {
  const {
    setActiveField,
    activeField,
    moveNextField,
    updateInfo,
    updateOfferText,
    currentInfo,
    setIsManualEntry
  } = useMainContext();
  const inputRef = useRef();

  useEffect(() => {
    if (inputId === activeField && inputRef?.current) {
      inputRef.current.focus();
    }

    return () => {};
  }, [inputId, activeField]);

  const handleChange = (value) => {
    if(inputId === "offer_text") {
      value = value.replace(/\,/g, "");
      updateOfferText(value);
      return;
    }
    updateInfo(inputId, value);
  };

  return (
    <OfferInfoContainer inputId={inputId} className={className}>
      <Input2
        label={label}
        inputId={inputId}
        type={type}
        disabled={disabled}
        shouldMoveNextOnEnter={shouldMoveNextOnEnter}
        ref={inputRef}
        value={currentInfo[inputId] ? currentInfo[inputId] : ""}
        onChange={handleChange}
        onFocus={() => setActiveField(inputId)}
        onEnter={() => shouldMoveNextOnEnter && moveNextField()}
        onClick={()=>setIsManualEntry(true)}
      />
    </OfferInfoContainer>
  );
};
